module.exports = __webpack_public_path__ + "static/duergar-9789f220f1137d30d62e9987183db5ed.jpg";